import styled from 'styled-components';
const ActionButtonGroupStyled = styled.div`
  margin-top: 24px;
  .export-wrapper {
    padding-left: 32px;
    height: 34px;
    .export {
      width: 107px;
      border-radius: 24px;
      color: #fff;
      .MuiSvgIcon-root {
        margin-right: 8px;
      }
    }
  }
`;
export default ActionButtonGroupStyled;
